import { createSelector } from '@opengov/compose-app/reselect';

import { claimsSelector } from './actionsAndReducer';
import {REPORTING_ADMIN_CLAIM, REPORTING_ENTITLEMENT, REPORTING_MANAGER_PRIVILEGE, REPORTING_DASHBOARD_READ_ALL} from "./consts";

export const getClaims = createSelector(claimsSelector, (state) => state.claims);
export const getClaimApiStatus = createSelector(claimsSelector, (state) => state.claimApiStatus.status);
export const getClaimsEntityUuid = createSelector(claimsSelector, (state) => state.claimsEntityUuid);
export const getReportingAdminClaimStatus = createSelector(getClaims, (claims) => claims.get(REPORTING_ADMIN_CLAIM));
export const getReportingEntitlementClaimStatus = createSelector(getClaims, (claims) => claims.get(REPORTING_ENTITLEMENT));
export const getReportingManagerPrivilegeClaimStatus = createSelector(getClaims, (claims) => claims.get(REPORTING_MANAGER_PRIVILEGE));
export const getReportingDashboardReadAllClaimStatus = createSelector(getClaims, (claims) => claims.get(REPORTING_DASHBOARD_READ_ALL));
